export const WIN_MESSAGES = ['Great Job!', 'Awesome', 'Well done!']

// Five Letters for two on Pearcade, opening in Malay
export const PEARCADE_URL =
  'https://pearcade.chyuang.com/games/five-letters?lang=ms&utm_source=malaywordle'
